<template>
  <div>
    <z-centralized-toolbar>
      <!-- <v-toolbar-items> -->
        <v-btn depressed rounded color="primary" to="/cadastros/vendedores/adicionar">
          <v-icon left>mdi-account-plus</v-icon>
          Adicionar Vendedor
        </v-btn>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="listar" :loading="$store.state.loading">
              <v-icon>refresh</v-icon>
            </v-btn>
          </template>
          Atualizar
        </v-tooltip>
      <!-- </v-toolbar-items> -->

      <div style="width: 300px;" class="ml-5">
        <v-text-field
          rounded
          outlined
          single-line
          dense
          autofocus
          clearable
          hide-details
          placeholder="Pesquisar"
          prepend-inner-icon="search"
          v-model="search"
        ></v-text-field>
      </div>
    </z-centralized-toolbar>

    <z-container>
      <h3 class="text-body-1 mb-3">Lista de Vendedores</h3>

      <v-card>
        <v-data-table :headers="headers" :items="vendedores" item-key="id" :loading="false" :search="search"
          :footer-props="$globals.FOOTER_PROPS">
          <template v-slot:item="{ item: vendedor }">
            <tr>
              <td>{{ vendedor.id }}</td>
              <td>{{ vendedor.nome }}</td>
              <td>{{ vendedor.celular }}</td>
              <td class="text-right">{{ vendedor.comissao | valorBR }} %</td>
              <td class="text-center">
                <v-btn icon @click="editar(vendedor)" class="ma-0">
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn icon @click="perguntarExcluir(vendedor)" class="ma-0">
                  <v-icon>delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </z-container>

    <z-dialogo ref="dialogoExcluir" titulo="Deseja excluir esse vendedor?" :dividers="true" largura="500px">
      <div slot="texto">
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle>Vendedor</v-list-item-subtitle>
              <v-list-item-title>{{ vendedor.nome }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>

      <v-btn text @click="$refs.dialogoExcluir.fechar()" :disabled="excluindo">Cancelar</v-btn>
      <v-btn color="primary darken-1" text :loading="excluindo" :disabled="excluindo"
        @click="confirmarExcluir">Excluir</v-btn>
    </z-dialogo>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      // globals,
      headers: [
        { text: "Código", value: "id", width: "150px" },
        { text: "Nome", value: "nome" },
        { text: "Celular", value: "celular" },
        { text: "Comissão", value: "comissao", align: 'right' },
        {
          text: "Opções",
          value: "",
          width: "200px",
          align: "center",
          sortable: false,
        },
      ],
      search: "",
      pagination: {},
      excluindo: false,
      vendedor: {},
      listagem: "Recentes",
    };
  },

  created() {
    this.setTitulo("Cadastro de Vendedores");
  },

  mounted() {
    this.listarVendedores();
  },

  methods: {
    ...mapMutations(["setTitulo", "LOADING_OFF"]),
    ...mapActions("vendedores", ["listar", "excluir", "abrir"]),

    async listarVendedores() {
      try {
        await this.listar();
      } catch (error) {
        this.$eventbus.erro("Erro ao listar vendedores!", error);
        throw error;
      } finally {
        this.LOADING_OFF();
      }
    },
    async editar(vendedor) {
      await this.abrir(vendedor.id);
      this.$router.push({
        name: "VendedoresEditar",
        params: { id: vendedor.id },
      });
    },

    perguntarExcluir(vendedor) {
      this.vendedor = vendedor;
      this.$refs.dialogoExcluir.abrir();
    },

    async confirmarExcluir() {
      try {
        this.excluindo = true;
        await this.excluir(this.vendedor.id);
      } finally {
        this.$refs.dialogoExcluir.fechar();
        this.excluindo = false;
        this.$eventbus.notificar("Vendedor excluído com sucesso!");
      }
    },
  },

  computed: {
    ...mapState("vendedores", ["vendedores"]),
  },
};
</script>

<style scoped></style>
